<template>
  <div class="flex justify-center items-center" style="width: 7.5rem">
    <div class="uNY2u87Ih6yCf2fiwE1Q">
      <div class="common-tabs-contentnone">
        <div
          v-if="tabIndex"
          @click="tabIndex = tabIndex - 1"
          class="_fhJToJ9pBZeoyjqe5a7 Zl2ywfksX9ooF1aQ02T9"
        >
          <svg-icon
            className="imageWrap_s"
            style="width: 0.22rem; height: 0.22rem"
            icon-class="comm_icon_fh--svgSprite:all"
          />
        </div>
        <div
          v-if="tabIndex != popList.length - 1"
          @click="tabIndex = tabIndex + 1"
          class="mHrSCgmC4tq6FJbB8Ak3 Zl2ywfksX9ooF1aQ02T9"
          style="transform: rotate(180deg)"
        >
          <svg-icon
            className="imageWrap_s"
            style="width: 0.22rem; height: 0.22rem"
            icon-class="comm_icon_fh--svgSprite:all"
          />
        </div>

        <div
          v-if="popList[tabIndex].content"
          style="
            padding: 0.2rem;
            font-size: 0.23rem;
            line-height: 1.64;
            box-sizing: border-box;
            text-align: left;
            max-height: 8rem;
            overflow: scroll;
          "
          @click="openUrl(popList[tabIndex])"
        >
          <div class="vinlOtU5EHTmNDU9ECDE">
            {{ popList[tabIndex].title }}
          </div>
          <p v-html="popList[tabIndex].content"></p>
        </div>
        <img
          v-else
          @click="openUrl(popList[tabIndex])"
          v-lazy="popList[tabIndex].image"
          style="width: 100%"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { userInfo } from '@/apis/modules/home.js';
export default {
  props: {
    popList: {
      type: [Object, Array],
      required: []
    }
  },
  data() {
    return {
      codeValue: '',
      inputFocus: false,
      tabIndex: 0,
      rememberPassword: window.localStorage.getItem('rememberPassword')
    };
  },
  computed: {
    ...mapState(['vuex_token_head','userInfo'])
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      if(this.$store.state.config.goto_bind_ws && this.userInfo.id && !this.userInfo.bind_ws && this.$store.state.config.bind_ws){
        userInfo({}).then(({ data,code }) => {
          if(code == 0){
            this.$store.state.config.goto_bind_ws = false;
            this.$store.commit('userInfo', data);
          }
        });
      }
    },
    openUrl(e) {
      if (e.jump_url && e.jump_url != '#') {
        if (/^http/.test(e.jump_url)) {
          window.open(e.jump_url, '_blank');
          return false;
        }
        if (e.jump_url == 'dailySignIn') {
          this.$store.commit('publicFun', ['CancelIsSigned_days', true]);
          return false;
        }
        if (e.jump_url == 'pdd') {
          this.$store.state.isShowWheelSpinEvent = true;
          return false;
        }else if (e.jump_url == 'recharge') {
          if (!this.vuex_token_head) {
            if (this.rememberPassword && this.rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          this.$store.commit('isDeposit', true);
          return false;
        }else if (e.jump_url == '#register') {
          if (!this.vuex_token_head) {
            if (this.rememberPassword && this.rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          return false;
        }else if (e.jump_url == '#BINDWS#') {
          let uid = '';
          if (this.vuex_token_head) {
            // 判断是否已经绑定
            if(this.userInfo.bind_ws)return false;
            uid = this.userInfo.id
          }
          this.$store.state.config.goto_bind_ws = true;
          this.$router.push({
            name: 'webviewCommon',
            params: {
              url: this.$store.state.config.bind_ws+'/'+window.location.hostname+'/'+uid
            }
          });
          return false;
        }
        this.$router.push({ name: e.jump_url });
      }
    }
  }
};
</script>

<style scoped>
.Zl2ywfksX9ooF1aQ02T9 {
  font-size: 0.22rem;
  height: 0.44rem;
  width: 0.44rem;
}
._fhJToJ9pBZeoyjqe5a7 {
  left: 0.08rem;
}
.mHrSCgmC4tq6FJbB8Ak3 {
  right: 0.08rem;
}
.Zl2ywfksX9ooF1aQ02T9 {
  -ms-flex-line-pack: center;
  -ms-flex-pack: center;
  align-content: center;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  font-size: 0.18rem;
  height: 0.36rem;
  justify-content: center;
  position: absolute;
  top: 48%;
  width: 0.36rem;
  z-index: 1;
}
.vinlOtU5EHTmNDU9ECDE {
  max-width: 90%;
  line-height: 1.38;
  margin: 0 auto 0.2rem;
  font-size: 0.3rem;
  color: var(--theme-text-color-darken);
  text-align: center;
}
.common-tab-item-active {
  background-color: rgba(var(--theme-primay-color-hex), 0.05);
}
.uNY2u87Ih6yCf2fiwE1Q {
  width: 80%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.2rem;
  position: relative;
  overflow: hidden;
  background-color: var(--theme-main-bg-color);
}
.common-tabs-contentnone {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.common-tab-item .imageWrap_s {
  color: var(--theme-text-color-lighten);
  margin-right: 0.08rem;
}
</style>
